<template>
  <section class="hero is-success is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-4 is-offset-4">
          <h3 class="title has-text-black">Login</h3>
          <hr class="login-hr" />
          <div class="box">
            <figure class="avatar">
              <img src="https://disctools.co.uk/img/DiSCloudBlack.png" />
            </figure>
            <form v-on:submit.prevent="login">
              <div class="field">
                <div class="control">
                  <input class="input is-large" v-model="email" type="email" placeholder="Your Email" autofocus />
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <input class="input is-large" v-model="password" type="password" placeholder="Your Password" />
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <select class="input" v-model="APIName">
                    <option value disabled selected>Select region</option>
                    <option v-for="region in this.regions" v-bind:key="region.Name">{{ region.Name }}</option>
                  </select>
                </div>
              </div>
              <button class="button is-block is-info is-large is-fullwidth">
                Login
                <i class="fa fa-sign-in" aria-hidden="true"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ToastProgrammatic as Toast } from "buefy";

const GlobalConfig = require("../config/index");

export default {
  name: "Login",
  data: function() {
    return {
      regions: [],
      email: "",
      password: "",
      APIName: ""
    };
  },
  beforeMount() {
    this.regions = GlobalConfig.API_SERVERS;
    if (localStorage.getItem("APIName") !== null) {
      this.APIName = localStorage.getItem("APIName");
    }
  },
  methods: {
    login: async function() {
      if (this.email === "") {
        Toast.open({
          message: "You must enter your email!",
          type: "is-danger"
        });
        return;
      }

      if (this.password === "") {
        Toast.open({
          message: "You must enter your password!",
          type: "is-danger"
        });
        return;
      }

      if (this.APIName === "") {
        Toast.open({
          message: "You must select a region!",
          type: "is-danger"
        });
        return;
      }

      localStorage.setItem("APIName", this.APIName);

      try {
        this.$cognitoAuth.authenticate(this.email, this.password, err => {
          if (err) {
            this.error = err;
          } else {
            this.$router.push("/home");
          }
        });
      } catch (err) {
        Toast.open({
          message: "Error with email or password!",
          type: "is-danger"
        });
        this.password = "";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html,
body {
  font-family: "Questrial", sans-serif;
  font-size: 14px;
  font-weight: 300;
}
.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

.login-hr {
  border-bottom: 1px solid black;
}

.has-text-black {
  color: black;
}

.field {
  padding-bottom: 10px;
}

.fa {
  margin-left: 5px;
}
</style>
